import React from 'react';
import styled from 'styled-components';
import Mind1 from '../../assets/Mind1.jpg';
import Mind2 from '../../assets/Mind2.jpg';
import Mind3 from '../../assets/Mind3.jpg';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  background-color: #f5f7fa;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  text-align: center;
  color: #2c3e50;
  margin-bottom: 20px;
  font-size: 2.5rem;
`;

const Paragraph = styled.p`
  color: #4f4f4f;
  line-height: 1.6;
  margin-bottom: 15px;
`;

const Section = styled.div`
  margin-bottom: 30px;
`;

function Mindscape3D() {
  return (
    <Container>
      <Title>3D Mindscape</Title>
      <Section>
        <Paragraph>
          Each person can be represented in a 3D mental landscape. The three dimensions are mood,
          cognition, and anxiety. Scores in each of the three dimensions will provide the GPS-like
          location in Mindscape (x, y, z coordinates) for each person at a particular moment in
          time. That would provide personalized information regarding a subject’s state (how ill or
          how well they are at that particular moment). Repeated testing over time would provide a
          series of points in the 3D Mindscape for each subject. The cloud generated by this series
          of points, its shape and location, would provide personalized information regarding a
          subject’s trait (diagnosis).
        </Paragraph>
        <Paragraph>
          Starting with simple numbers from quantitative behavioral questionnaires first, then from
          biomarker blood panels, the scores on the three dimensions (anxiety, mood, and cognition)
          can be developed over time to be more comprehensive, integrating a variety of behavioral,
          biomarker, and genetic data. A single time-point testing can provide information related
          to disease state, biomarker levels, and clinical severity. Repeated measures over time can
          provide information related to diagnostic traits, response to treatment, and personalized
          diagnosis.
        </Paragraph>
        <Paragraph>
          Good clinicians currently use consensus diagnostic criteria and clinical intuition/pattern
          recognition to approximately classify patients in what is the rough equivalent of
          different 3D Mindscape regions. For example, depression with psychotic features can be low
          mood, low cognition, and high anxiety. The game-changer in our ability to diagnose and
          treat people will occur when these operations are made explicit as opposed to implicit,
          objective as opposed to subjective, and quantitative as opposed to qualitative. People who
          have extreme scores in the dimensions of the 3D Mindscape (outliers) are either clinically
          ill or super-performers. Within limits, finding the right environmental fit for different
          people may make the difference between needing clinical treatment and having a very
          productive life. When that is not enough, moving people in their 3D Mindscape with
          appropriate treatments will increase their congruence to the environment and ability to
          function well.
        </Paragraph>
      </Section>
      <img src={Mind1} alt="Lab Mission Visual" />
      <img src={Mind2} alt="Lab Mission Visual" />
      <img src={Mind3} alt="Lab Mission Visual" />
    </Container>
  );
}

export default Mindscape3D;
